import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import AuthState from './auth.state';
import { isValidAttributesArray } from '@/utils';

const initialState = AuthState;

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    SET_AUTH: (state, action: PayloadAction<AuthResponse>) => {
      // Handle attributes that can be either a string (JSON) or already an array
      const rawAttributes = action.payload.user?.attributes;
      let parsedAttributes: unknown = rawAttributes;

      // If attributes is a string, parse it
      if (typeof rawAttributes === 'string') {
        try {
          parsedAttributes = JSON.parse(rawAttributes);
        } catch (error) {
          console.error('Failed to parse attributes string:', error);
          parsedAttributes = [];
        }
      }

      // Validate and set permissions
      const permissions = isValidAttributesArray(parsedAttributes)
        ? (parsedAttributes as AppProgram[])
        : [];
      state.accessToken = action.payload.accessToken;
      state.jwtToken = action.payload.id;
      state.user = action.payload.user;
      state.ttl = action.payload.ttl;
      state.createdAt = action.payload.createdAt;
      state.permissions = permissions;
    },
  },
});

export default authSlice.reducer;
